import LazyImage from "../components/LazyImage";
import logo from "../assets/images/logoOne.png";

const Home = () => (
  <div className="p-10 text-center flex flex-col items-center">
    <h1 className="uppercase romanBold text-lg py-10 lg:text-4xl tracking-[0.3em]">
      Welcome to
    </h1>
    <LazyImage src={logo} alt="Motographic" className="w-1/3 py-10" priority />
  </div>
);

export default Home;
